import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-preview-eye-icon',
  standalone: true,
  templateUrl: './preview-eye-icon.component.html',
  styleUrls: ['./preview-eye-icon.component.scss']
})
export class PreviewEyeIconComponent {
  @Input() width: number | string = 20;
  @Input() height: number | string = 20;
}
